import React from 'react'

export const UploadFilesAsync = React.lazy(() => import('./upload-files'))
